@if (likedListToBeUpdated && (favouritesListToBeUpdated$ | async); as favouritesListToBeUpdated) {
  <ion-header class="ion-no-border" no-border-bottom>
    <ion-toolbar>
      <div class="header">
        <img
          src="/assets/images/icons-svg/arrow-right.svg"
          class="header__back"
          (click)="goBack()"
        />
        <app-text
          [text]="galleryData.chosenImgIndex | photoViewCounter: galleryData.images.length"
          [textSize]="TextSizes.h1Header"
          [textType]="TextType.base"
        ></app-text>
        <img
          src="assets/images/icons-svg/posts/post-menu.svg"
          (click)="handleOpenModalMenu(favouritesListToBeUpdated)"
        />
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content [forceOverscroll]="false">
    <div class="gallery">
      @if (config) {
        <swiper #slides [zoom]="zoomSettings" [config]="config" (slideChange)="slideChanged()">
          @for (img of galleryData.images; track img) {
            <ng-template swiperSlide>
              <div class="swiper-zoom-container">
                <img [src]="img | getImagePreview: ImagePreviewType.fullScreen" />
              </div>
            </ng-template>
          }
        </swiper>
      }
      @if (!!galleryData.photoReportData) {
        <div class="gallery__title">
          <b>{{ galleryData.photoReportData.name }} ({{ galleryData.photoReportData.city }})</b>
          <b>{{ galleryData.photoReportData.category }}</b>
        </div>
      }
    </div>
  </ion-content>
  <ion-footer>
    @if (!galleryData.hideInputs && galleryData.images[galleryData.chosenImgIndex]) {
      <app-post-information
        [postId]="galleryData.images[galleryData.chosenImgIndex].id"
        [viewType]="ViewTypesList.gallery"
        [postIsLiked]="
          likedListToBeUpdated | isImageLiked: galleryData.images[galleryData.chosenImgIndex]
        "
        [postLikesCount]="
          likedListToBeUpdated | getImagesLikesCount: galleryData.images[galleryData.chosenImgIndex]
        "
        [postCommentsCount]="galleryData.images[galleryData.chosenImgIndex].commentCount"
        [class.liked-icon]="
          likedListToBeUpdated | isImageLiked: galleryData.images[galleryData.chosenImgIndex]
        "
        [onCommentIconClick]="openGalleryWithComments"
      ></app-post-information>
    }
  </ion-footer>
}
